import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Services extends Page{
    constructor(){
        super({
            id : 'services',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}